import { ref } from '@vue/reactivity';
import { AxiosPromise } from 'axios';
import { Toast } from 'vant';
import { errorParse } from '@/utils/errorParse';
interface IRequestConfig {
  // 是否手动请求
  manual?:boolean;
  // 防抖毫秒数
  debounce?:number;
  // swr的缓存key
  cacheKey?:string;
  // 是否关闭Toast报错
  closeToast?:boolean;
}
// 缓存
const cache:Record<string, any> = {};
// 防抖
let timer:NodeJS.Timeout | undefined;

/**
 * @description 执行防抖
 * @author Wynne
 * @date 2021-03-16
 * @param {IRequestConfig} [config]
 */
function runDebounce(config?:IRequestConfig) {
  return new Promise((resolve, reject) => {
    if(timer)
      clearTimeout(timer);
    // 是否配置了防抖
    if (config?.debounce && config.debounce > 0) {
      timer = setTimeout(() => {
        resolve(true);
      }, config.debounce);
    } else {
      resolve(true);
    }
  });
}

/**
 * @description useRequest Hooks
 * @author Wynne
 * @date 2021-03-16
 * @param {() => AxiosPromise<T>} request
 * @param {IRequestConfig} [config]
 */
export function useRequest<T>(request:() => AxiosPromise<T>, config?:IRequestConfig) {
  // 是否加载中
  const loading = ref(false);
  // 返回数据
  const data = ref<T>();
  // 执行请求方法
  const run = ():AxiosPromise<T> => new Promise((resolve, reject) => {
    if (config?.cacheKey && cache) {
      data.value = cache[config.cacheKey];
    }
    loading.value = true;
    runDebounce(config).then(() => {
      request().then((res) => {
        loading.value = false;
        if (config?.cacheKey) {
          cache[config?.cacheKey] = res.data;
        }
        if (/^2\d/.test(res.status.toString())) {
          data.value = res.data;
        } else if (!config?.closeToast) {
          // 如果非200开头，则展示通用errorCode提示
          Toast(errorParse((res.data as any).error_code));
        }
        resolve(res);
      }).catch((err) => {
        reject(err);
        loading.value = false;
        if (!config?.closeToast) {
          Toast(errorParse(err.error_code));
        }
      });
    }).catch((e) => console.log(e));
  });
  // 如果不需要立即执行
  if (!config?.manual) {
    run();
  }
  return { loading, data, run };
}
